import React, { useState } from "react";
import CommentMat from "./comment-mat";
import { setVoteCommand } from "../../services/material-services";
import { useAuth } from "../../hooks/useAuth";
import { Button, Rating, TextField, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import StarIcon from '@mui/icons-material/Star';

function CommentMats({ materials }) {
  const { authData, authDataLang } = useAuth();
  const [newComment, setNewComment] = useState('');
  const [value, setValue] = useState(4);

  const sendComment = () => {
    setVoteCommand(authData?.token, authData?.user.id, materials?.material?.id, newComment, value)
      .then(resp => {
        setNewComment('');
        materials?.material.votecomments.unshift(resp);
      })
      .catch(error => {
        console.error("Error submitting comment:", error);
      });
  };

  return (
    <div>
      {authData ? (
        <div dir={authDataLang?.view_sts ? "ltr" : "rtl"}>
          <Rating
            name="hover-feedback"
            value={value}
            precision={0.5}
            onChange={(event, newValue) => setValue(newValue)}
            emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
          />
          <TextField
            label={authDataLang?.site_langs?.desc_comment}
            multiline
            fullWidth
            rows={4}
            variant="outlined"
            value={newComment}
            sx={{ fontFamily: 'b_mitra' }}
            onChange={e => setNewComment(e.target.value)}
          />
          <Button
            onClick={sendComment}
            disabled={!newComment}
            variant="contained"
            color="primary"
          >
            {authDataLang?.site_langs?.desc_menu_msg_send}
          </Button>
        </div>
      ) : (
        <div>
          <Link to="/login">
            <Typography fontFamily="Segoe UI" component="h4" variant="h4">
              {authDataLang?.site_langs?.desc_account_login}
            </Typography>
          </Link>
        </div>
      )}

      {materials?.material?.votecomments && (
        <CommentMat comments={materials?.material?.votecomments} />
      )}
    </div>
  );
}

export default CommentMats;
